import { notFound } from '@tanstack/react-router'
import type { QueryClient } from '@tanstack/react-query'

import { RETAIL_MEMBER_TIERS_ENABLED } from '@/lib/retail-features'
import { requireServerFlag } from '@/lib/server-flag-guard'

/**
 * Gác route của module bán lẻ (/retail/*, Báo cáo › Website / Zalo Mini App)
 * theo SHOP_ENABLED của bản deploy (/auth/me `shop_enabled`): tắt → trang không
 * tồn tại, như menu đã ẩn.
 */
export function requireShopEnabled(client: QueryClient): Promise<void> {
    return requireServerFlag(client, 'server:shop')
}

/** Gác trang Hạng thành viên: đang ẩn (ERP-07) → trang không tồn tại. */
export function requireMemberTiersEnabled(): void {
    if (!RETAIL_MEMBER_TIERS_ENABLED) throw notFound()
}
